import React from 'react';
import HeadingAndSupportingText from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingText';

const FeedTextBlock = (): JSX.Element => (
  <HeadingAndSupportingText
    heading={{
      type: 'heading',
      size: 'xl',
      text: 'The most $1M+ communities',
    }}
    supportingText={{
      type: 'paragraph',
      size: 'lg',
      color: 'text-tertiary',
      text: 'We use our data, expertise, and vision to turn the art of community into a science. Everything we learn? We pass it right onto you through our software, stories, and step-by-step masterclass.',
    }}
    subHeading={{
      type: 'paragraph',
      size: 'lg',
      color: 'text-brand-secondary',
      text: 'What makes Mighty different?',
      fontWeight: 'font-weight-semibold',
    }}
    subHeadingGap='spacing-lg'
    gap='spacing-2xl'
  />
);

export default FeedTextBlock;
